import React from 'react'
import styles from './style.module.scss'

const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.bottom}>
        <div className="row">
          <div className="col-sm-6">
            <div className={styles.copyright}>
              <span>
                &copy; 2020{' '}
                <a href="http://unabridgedsoftware.com/" target="_blank" rel="noopener noreferrer">
                  Unabridged Software
                </a>
                <br />
                All rights reserved
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer
